export default __webpack_public_path__ + "static/media/rafa11.11c45c6f.jpg";